import { MessagesContext } from "contexts/messagesContext";
import { ReplyContext } from "contexts/replyContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useHistory, useLocation } from "react-router-dom";
import { Alert, Input, Nav, NavItem, NavLink } from "reactstrap";
import { serviceGetChatById, serviceGetChats, serviceGetFilterChat, servicePutChat } from "services/chats";
import { getDepartment, getDepartmentByID } from "services/departments";
import { socketIO } from "services/socket";
import { serviceGetTicketById, servicePutTickets } from "services/tickets";
import SimpleBar from "simplebar-react";
import { useDebounce } from "use-debounce";
import { Icon } from "../../../components/Component";
import ContentAlt from "../../../layout/content/ContentAlt";
import Head from "../../../layout/head/Head";
import { ChatAsideBody } from "./ChatAsideBody";
import ChatBody from "./ChatBody";
import { ChatContext } from "./ChatContext";
import ChatModalFilter from "./ChatModalFilter";
import ChatModalFilterCampaign from "./ChatModalFilterCampaign";
import ChatModalFilterDate from "./ChatModalFilterDate";
import ChatModalFilterDepartment from "./ChatModalFilterDepartment";

import { playSound } from "layout/Index";
import { serviceSendMessage } from "services/messages";
import { serviceGetTicketsById } from "services/tickets";
import ChatFilterUser from "./ChatFilterUser";
import { getPermission } from "utils/Utils";
import {
  addChatWithoutDuplication,
  chatMatchesActiveFilters,
  chatMatchesActiveTab,
  chatNoDuplicate,
  combine2ChatNoDuplicate,
  getUnprocessedMessages,
  removeChatFromLists,
} from "./utils/ChatUtils";

const Chat = () => {
  const {
    chatListState,
    chatListIdState,
    selectedChatState,
    selectedIdState,
    filteredMessageListState,
    filteredChatListState,
    textFilterState,
  } = useContext(ChatContext);

  const userDetail = JSON.parse(localStorage.getItem("userDetail"));

  const [chatList, setChatList] = chatListState;
  const [, setChatIdList] = chatListIdState;
  const [, setSelectedChat] = selectedChatState;
  const [filteredChatList, setFilteredChatList] = filteredChatListState;
  const [, setFilteredMessageList] = filteredMessageListState;
  const [selectedId, setSelectedId] = selectedIdState;
  const [textFilter, setTextFilter] = textFilterState;

  const [filterTab, setFilterTab] = useState("all");
  const [isBotFilter, setIsBotFilter] = useState(false);
  const [afterCursorSearchedMessage, setAfterCursorSearchedMessage] = useState({});
  const [filterTag, setFilterTag] = useState([]);
  const [filterCampaign, setFilterCampaign] = useState([]);
  const [searchText] = useDebounce(textFilter, 500);
  const [mobileView, setMobileView] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const location = useLocation();
  const history = useHistory();
  const [isModalTagAssignOpen, setIsModalTagAssignOpen] = useState(false);
  const [checkedTag, setCheckedTag] = useState([]);
  const { messagesValue, salesUpdate } = useContext(MessagesContext);
  const [newMessages] = messagesValue;
  const processedMessageCountRef = useRef(newMessages.length);
  const [newSales] = salesUpdate;
  const [cookies] = useCookies(["user"]);
  const [isModalTagFilterOpen, setIsModalTagFilterOpen] = useState(false);
  const [isModalCampaignFilterOpen, setIsModalCampaignFilterOpen] = useState(false);
  const [filterDepartment, setFilterDepartment] = useState([]);
  const [filterDate, setFilterDate] = useState({ dateFrom: null, dateTo: null });
  const [isModalDateFilterOpen, setIsModalDateFilterOpen] = useState(false);
  const [isModalDepartmentFilterOpen, setIsModalDepartmentFilterOpen] = useState(false);
  const [isModalFilterUserOpen, setIsModalFilterUserOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [replyMessage, setReplyMessage] = useState(null);
  const [contextMessage, setContextMessage] = useState(null);
  const [afterCursorChat, setAfterCursorChat] = useState(null);
  const [phoneNotFoundMessage, setPhoneNotFoundMessage] = useState(null);

  const [filterUserId, setFilterUserId] = useState("");
  const [filterUserName, setFilterUserName] = useState("");

  const RESOLVED_BANNER_DISMISSED_KEY = "ticketResolvedBannerDismissed";

  const [showResolvedBanner, setShowResolvedBanner] = useState(
    () => localStorage.getItem(RESOLVED_BANNER_DISMISSED_KEY) !== "true",
  );

  let roleFunctions = getPermission()["chats"]?.access || [];

  const ALL_DEPT = "Access_All_Dept";
  const OWN = "Access_Own";
  const BOT_ID = "3ef9f486-ddad-46ed-b568-f7b32a62262f";

  const refreshChatList = async () => {
    const status = activeTab !== "all" ? activeTab.toUpperCase() : "";

    setIsLoading(true);

    const responseGetChats = await serviceGetChats(
      cookies.SIDikey,
      cookies.id,
      cookies.departmentIds,
      status,
      filterTag.toString(),
      roleFunctions,
      cookies.role.name,
      filterUserId,
      filterCampaign.toString(),
      "",
      filterDepartment.toString(),
      filterDate.dateFrom ? filterDate.dateFrom.toISOString() : "",
      filterDate.dateTo ? filterDate.dateTo.toISOString() : "",
    );

    if (new RegExp(/20+/).test(responseGetChats.status)) {
      let data = responseGetChats.data.data;

      const metaData = responseGetChats.data.meta;
      setAfterCursorChat(metaData);

      const noDuplicateChat = chatNoDuplicate(data);
      // Backend already sorted by updatedAt DESC, no need to re-sort
      setChatList(noDuplicateChat);
      setChatIdList(
        data.map((item) => {
          return item.id;
        }),
      );
    } else {
    }

    setIsLoading(false);
  };

  const filterChatByUserId = async (userId) => {
    // setIsLoading(true);
    setFilterUserId(userId);
    setIsModalFilterUserOpen(false);
    setSelectedId(null);
  };

  useEffect(() => {
    if (!isModalTagAssignOpen) {
      if (!isLoading) refreshChatList();
    }
  }, [activeTab, filterTag, filterUserId, filterCampaign, filterDepartment, filterDate]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }
  }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  // Socket bisa putus-sambung diam-diam (background tab, jaringan blip) dan
  // socket.io tidak replay event yang lewat pas gap itu — chat baru/UNOPENED
  // bisa hilang dari list walau datanya valid di DB. Refetch penuh saat
  // koneksi balik supaya list sinkron lagi.
  const refreshChatListRef = useRef(refreshChatList);
  refreshChatListRef.current = refreshChatList;

  useEffect(() => {
    const handleReconnect = () => refreshChatListRef.current();
    socketIO.io.on("reconnect", handleReconnect);

    return () => socketIO.io.off("reconnect", handleReconnect);
  }, []);

  const checkChatIDinUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const chatID = params.get("chatID");

    if (chatID && chatList && !isLoading) {
      setSelectedId(chatID);
    }
  };

  // if the opened chat have new message
  // const playSound = () => {
  //   try {
  //     const sound = new Audio(lonceng4);
  //     sound.play();
  //   } catch (error) {
  //     //console.log(error);
  //   }
  // };

  const refreshChatDataOnNewMessage = (chatData, newMessage) => {
    // Early return for bot messages if user can't view chatbot
    if (!roleFunctions.includes("View_Chatbot") && newMessage.chat?.userId === BOT_ID) {
      if (selectedId === newMessage.chat?.id) setSelectedId(null);
      return { newChats: [...chatData], found: false, foundIndex: -1 };
    }

    const foundIndex = chatData.findIndex((chat) => newMessage?.chat?.id === chat.id);
    const found = foundIndex !== -1;

    // If message doesn't match any chat, return original data
    if (!found) return { newChats: [...chatData], found, foundIndex };

    // Create a copy of the chat data array
    const newChats = [...chatData];

    // Get the chat that needs to be updated
    let updatedChat = { ...newChats[foundIndex] };

    // Update user information if available
    if (newMessage.chat?.user) {
      updatedChat.user = newMessage.chat.user;
      updatedChat.userId = newMessage.chat.userId;
    }

    // Update tickets if present
    if (newMessage?.tickets) {
      updatedChat.tickets = newMessage.tickets;
    }

    // Update tags if present
    if (newMessage?.tags || newMessage?.chat?.tags) {
      updatedChat.tags = newMessage?.chat?.tags || newMessage?.tags;
    }

    // Update last message for regular messages
    if (newMessage.type !== "tag-update" && newMessage.type !== "tag-update-resolve") {
      updatedChat.lastMessage = newMessage;

      // Play sound for incoming user messages
      if (!newMessage.fromMe) {
        try {
          playSound();
        } catch (error) {
          console.log(error);
        }
      }
    }

    // Update unread counts
    const unreadCountFields = [
      "unreadCount",
      "unreadCountAdmin",
      "unreadCountCs",
      "unreadCountHead",
      "unreadCountSuper",
      "unreadCountAuditor",
      "unreadCountSysAdmin",
    ];

    unreadCountFields.forEach((field) => {
      if (newMessage.chat?.[field] !== undefined) {
        updatedChat[field] = newMessage.chat[field];
      }
    });

    // Update status fields
    const statusFields = [
      "status",
      "adminStatus",
      "csStatus",
      "headStatus",
      "superStatus",
      "auditorStatus",
      "sysAdminStatus",
    ];

    statusFields.forEach((field) => {
      if (newMessage.chat?.[field]) {
        updatedChat[field] = newMessage.chat[field];
      }
    });

    // Handle selected chat updates
    if (selectedId === newMessage.chatId) {
      const { statusObj, ticketStatusObj } = determineStatusUpdates(updatedChat, cookies);

      if (newMessage.fromMe) {
        updatedChat = applyStatusUpdates(updatedChat, statusObj);

        // Update chat and ticket statuses if needed
        if (!roleFunctions.includes("View_Chatbot")) {
          if (ticketStatusObj) {
            servicePutChat(cookies.SIDikey, updatedChat.id, { ...statusObj });

            if (updatedChat.tickets && updatedChat.tickets.length > 0) {
              updateTicketStatusAndEmit(updatedChat, cookies, ticketStatusObj);
            }
          }
        } else if (statusObj.currentStatus === "UNOPENED") {
          servicePutChat(cookies.SIDikey, updatedChat.id, { ...statusObj });
        }
      }
    }

    // Remove the chat from its original position
    newChats.splice(foundIndex, 1);

    // If updated status no longer matches the active filter, drop it from the list
    if (!chatMatchesActiveTab(updatedChat, activeTab, cookies.role.name)) {
      return { newChats: [...newChats], found, foundIndex };
    }

    // Add the updated chat to the beginning of the array
    return { newChats: [updatedChat, ...newChats], found, foundIndex };
  };

  // Helper function to determine status updates based on user role
  const determineStatusUpdates = (chat, cookies) => {
    const roleMap = {
      SALES: {
        currentStatus: chat.status,
        statusField: "status",
        unreadField: "unreadCount",
        condition: chat.userId === cookies.id,
      },
      CS: {
        currentStatus: chat.csStatus,
        statusField: "csStatus",
        unreadField: "unreadCountCs",
        condition: chat.userId === cookies.id,
      },
      "SUPER ADMIN": {
        currentStatus: chat.superStatus,
        statusField: "superStatus",
        unreadField: "unreadCountSuper",
        condition: false,
      },
      HEAD: {
        currentStatus: chat.headStatus,
        statusField: "headStatus",
        unreadField: "unreadCountHead",
        condition: false,
      },
      AUDITOR: {
        currentStatus: chat.auditorStatus,
        statusField: "auditorStatus",
        unreadField: "unreadCountAuditor",
        condition: false,
      },
      "SYSTEM ADMIN": {
        currentStatus: chat.sysAdminStatus,
        statusField: "sysAdminStatus",
        unreadField: "unreadCountSysAdmin",
        condition: false,
      },
      default: {
        currentStatus: chat.adminStatus,
        statusField: "adminStatus",
        unreadField: "unreadCountAdmin",
        condition: false,
      },
    };

    const role = roleMap[cookies.role.name] || roleMap.default;
    const currentStatus = role.currentStatus;
    const newStatus = currentStatus === "UNOPENED" ? "OPENED" : currentStatus;

    const statusObj = { [role.statusField]: newStatus, [role.unreadField]: 0, currentStatus };

    const ticketStatusObj = role.condition ? { status: newStatus } : null;

    return { statusObj, ticketStatusObj };
  };

  // Helper function to apply status updates to a chat
  const applyStatusUpdates = (chat, statusObj) => {
    const updatedChat = { ...chat };

    switch (cookies.role.name) {
      case "SALES":
        updatedChat.status = statusObj.status;
        updatedChat.unreadCount = 0;
        break;
      case "CS":
        updatedChat.csStatus = statusObj.csStatus;
        updatedChat.unreadCount = 0;
        break;
      case "SUPER ADMIN":
        updatedChat.superStatus = statusObj.superStatus;
        break;
      case "HEAD":
        updatedChat.headStatus = statusObj.headStatus;
        break;
      case "AUDITOR":
        updatedChat.auditorStatus = statusObj.auditorStatus;
        break;
      case "SYSTEM ADMIN":
        updatedChat.sysAdminStatus = statusObj.sysAdminStatus;
        break;
      default:
        updatedChat.adminStatus = statusObj.adminStatus;
        break;
    }

    return updatedChat;
  };

  const updateTicketStatusAndEmit = async (ch, cookies, currentTicketStatusObj) => {
    if (ch.tickets && ch.tickets.length > 0) {
      try {
        await servicePutTickets(ch.tickets[0].id, cookies.SIDikey, { ...currentTicketStatusObj });

        ch.tickets[0].status = currentTicketStatusObj.status;
      } catch (error) {
        console.error("Error while updating ticket:", error);
      }
    }
  };

  useEffect(() => {
    if (!salesUpdate[0]) {
      return;
    }

    assignChatFromRotator(salesUpdate);
  }, [newSales]); // eslint-disable-line react-hooks/exhaustive-deps

  const assignChatFromRotator = async (emitData) => {
    if (!Array.isArray(emitData)) {
      console.error("Invalid emitData: Expected an array");
      return;
    }

    let newChatSales = [];
    const updatedChat = [...chatList]; // Clone current chat list to avoid direct mutations

    for (const salesArr of emitData) {
      if (!Array.isArray(salesArr)) {
        console.warn("Invalid salesArr: Expected an array");
        continue;
      }

      for (const sales of salesArr) {
        if (!sales || !sales.chat || !sales.chatId || !sales.ticket) {
          console.warn("Invalid sales object: Missing necessary properties");
          continue;
        }

        const newChat = sales.chat;
        if (selectedId === newChat.id) {
          setSelectedId(null);
        }

        newChat.tickets = sales.ticket;
        newChat.lastMessage = sales.chat.messages[0];
        if (newChat.channel && sales.department) {
          newChat.channel.department = sales.department;
        }

        const targetChatIndex = updatedChat.findIndex((item) => item.id === sales.chatId);

        if (roleFunctions.includes(OWN)) {
          // If user has own/sales role
          if (sales?.chat?.user?.id === cookies.id) {
            // CHAT BUAT SALES INI

            await handleNewChatAssignment(sales, newChat, targetChatIndex, updatedChat, newChatSales);
          } else {
            // If the chat not for him
            if (targetChatIndex >= 0) {
              updatedChat.splice(targetChatIndex, 1);
              if (selectedId === sales.chatId) {
                setSelectedId(null);
              }
            }
          }
        } else {
          // If user is not a sales representative
          // updatedChat[targetChatIndex] = newChat
          // updatedChat[targetChatIndex].tickets = sales.ticket;
          await handleNonSalesAssignment(sales, newChat, targetChatIndex, updatedChat, newChatSales);
        }
      }
    }

    const noDuplicateChat = combine2ChatNoDuplicate(newChatSales, updatedChat);

    setChatList(noDuplicateChat);
  };

  async function handleNewChatAssignment(sales, newChat, targetChatIndex, updatedChat, newChatSales) {
    try {
      playSound();
    } catch (error) {
      console.error("Error playing sound:", error);
    }

    if (targetChatIndex >= 0) {
      if (updatedChat[targetChatIndex].status === "RESOLVED") {
        try {
          updatedChat[targetChatIndex].tags = newChat.tags ?? [];
        } catch (error) {
          ////console.log('updatedChat[targetChatIndex].tags', error);
        }
      }

      updatedChat[targetChatIndex] = newChat;
      updatedChat[targetChatIndex].tickets = sales.ticket;

      if (selectedId === updatedChat[targetChatIndex].id) {
        setSelectedId(null);
      }
    } else if (updatedChat.length === 0 || targetChatIndex < 0) {
      // jika chat tidak ditemukan atau tidak memiliki chat sebelumnya
      if (chatMatchesActiveTab(newChat, activeTab, cookies.role.name)) {
        newChatSales.push(newChat);
      }
      if (selectedId === newChat.id) {
        setSelectedId(null);
      }
    }
  }

  async function handleNonSalesAssignment(sales, newChat, targetChatIndex, updatedChat, newChatSales) {
    try {
      playSound();
    } catch (error) {
      console.error("Error playing sound:", error);
    }

    if (targetChatIndex >= 0) {
      updatedChat[targetChatIndex] = newChat;
      updatedChat[targetChatIndex].tickets = sales.ticket;
    } else if (updatedChat.length === 0 || targetChatIndex < 0) {
      // jika chat tidak ditemukan atau tidak memiliki chat sebelumnya
      if (chatMatchesActiveTab(newChat, activeTab, cookies.role.name)) {
        newChatSales.push(newChat);
      }
    }
  }

  useEffect(() => {
    //Jika ada newMessages or isLoading triggered

    // jika masih loading
    if (isLoading) {
      return;
    }

    const { toProcess, nextCount } = getUnprocessedMessages(newMessages, processedMessageCountRef.current);
    processedMessageCountRef.current = nextCount;

    for (const newMessage of toProcess) {
      if (!newMessage) {
        continue;
      }

      let currentChats = searchText ? [...filteredChatList] : [...chatList];

      let indexChat = currentChats.findIndex((cht) => cht.id === newMessage.chatId);

      if (newMessage.type === "status-update") {
        if (indexChat !== -1) {
          let updatedChat = {
            ...currentChats[indexChat],
            ...newMessage.chat,
          };
          // Update status chat di view saat ini tanpa membuangnya dari list.
          // Chat tetap terlihat di tab yang sedang aktif sampai user berpindah tab.
          // Saat user ganti tab, refreshChatList() dipanggil dan mengambil data
          // segar dari API dengan filter tab yang tepat.
          currentChats[indexChat] = updatedChat;
          const noDuplicateChat = chatNoDuplicate(currentChats);
          searchText ? setFilteredChatList(noDuplicateChat) : setChatList(noDuplicateChat);
        }
        continue;
      } else if (newMessage.type === "tag-update" || newMessage.type === "tag-update-resolve") {
        if (indexChat > -1) {
          // Pakai spread supaya lastMessage dan semua field lain ter-preserve
          currentChats[indexChat] = {
            ...currentChats[indexChat],
            tags: newMessage.tags,
          };

          const noDuplicateChat = chatNoDuplicate(currentChats);
          //console.log('🧹 chatNoDuplicate for tags', performance.now() - beforeNoDuplicateTime, 'ms');

          searchText ? setFilteredChatList(noDuplicateChat) : setChatList(noDuplicateChat);
          //console.log('💾 setState for tag update', performance.now() - beforeSetStateTime, 'ms');
        }
        //console.log('✅ Tag update completed', performance.now() - tagUpdateTime, 'ms');
        //console.log('🏁 Total execution time', performance.now() - startTime, 'ms');
        continue;
      } else {
        // jika Filter Bot aktif
        if (isBotFilter && newMessage?.chat?.userId !== BOT_ID) {
          continue;
        }
      }

      // ASSIGN
      // jika kamu adalah SALES atau OWN USER
      if (roleFunctions.includes(OWN)) {
        if (newMessage?.chat?.userId && newMessage?.chat?.userId !== cookies.id) {
          try {
            removeChatById(newMessage?.chat?.id);
          } catch (error) {}
          continue;
        }
      }

      // Jika bukan access all dept
      if (!roleFunctions.includes(ALL_DEPT)) {
        if (
          newMessage?.chat?.channel?.departmentId &&
          !cookies.departmentIds.includes(newMessage?.chat?.channel?.departmentId)
        ) {
          removeChatById(newMessage?.chat?.id);
          continue;
        }
      }

      // SALES dan CS tidak menerima chatbot
      if (!roleFunctions.includes("View_Chatbot")) {
        if (newMessage?.chat?.fromBot || newMessage?.chat?.userId === BOT_ID) {
          removeChatById(newMessage?.chat?.id);
          continue;
        }
      }

      // Guard: filter user/sales aktif — cek awal sebelum fetch data tambahan
      if (filterUserId && newMessage?.chat?.userId && newMessage?.chat?.userId !== filterUserId) {
        removeChatById(newMessage?.chat?.id);
        continue;
      }

      if (chatList.length === 0) {
        addNewChatToChats(newMessage);
        continue;
      }
      let addNewMessage = null;
      let newChats = null;
      let found = null;

      //jika ada filter chat di sebelumnya
      if (searchText) {
        addNewMessage = refreshChatDataOnNewMessage(filteredChatList, newMessage);

        newChats = addNewMessage.newChats;
        found = addNewMessage.found;
        if (found) {
          setFilteredChatList(newChats);
        }
      } else {
        addNewMessage = refreshChatDataOnNewMessage(chatList, newMessage);

        newChats = addNewMessage.newChats;
        found = addNewMessage.found;
      }

      if (found) {
        const targetChat = newChats.find((itm) => itm.id === newMessage.chatId);

        addNewTicketToChat(newChats, newMessage.ticketId, targetChat, newMessage);
      } else {
        if (chatList && chatList.length > 0) {
          addNewChatToChats(newMessage);
        } else {
          refreshChatList();
        }
      }
    }
  }, [newMessages, isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  const removeChatById = async (chatId) => {
    if (!chatId) return;

    // remove chat yang ada dalam kuasa bot — also drop it from filteredChatList,
    // which is what's rendered while a search is active, or it leaks through
    // (see OPI-439: stale chat kept showing in a filtered/searched view).
    const { newChatList, newFilteredChatList } = removeChatFromLists(chatId, chatList, filteredChatList);
    setChatList(newChatList);
    if (newFilteredChatList !== filteredChatList) {
      setFilteredChatList(newFilteredChatList);
    }

    if (selectedId === chatId) {
      setSelectedId(null);
    }
  };

  const addNewTicketToChat = async (newChats, newTicketId, targetChat, newMessage) => {
    const invalidTypes = ["tag-update"];

    let findTargetChatIndex;
    if (targetChat) {
      findTargetChatIndex = newChats.findIndex((itm) => itm.id === targetChat.id);
      if (!invalidTypes.includes(newMessage?.type)) {
        newChats[findTargetChatIndex].lastMessage = newMessage;
      }
    }
    if (newTicketId && findTargetChatIndex >= 0) {
      const resNetTicket = await serviceGetTicketsById(cookies.SIDikey, newTicketId);
      newChats[findTargetChatIndex].tickets = resNetTicket.data.data;
      newChats[findTargetChatIndex].ticketId = resNetTicket.data.data[0].id;

      if (!targetChat?.tags || targetChat?.tags.length === 0) {
        const resNewChat = await serviceGetChatById(cookies.SIDikey, targetChat.id);
        ////console.log('getNewTags by get chat', resNewChat)

        if (resNewChat.status === 200) {
          newChats[findTargetChatIndex].tags = resNewChat.data.tags;
        } else {
          newChats[findTargetChatIndex].tags = [];
        }
      } else {
        newChats[findTargetChatIndex].tags = targetChat.tags;
      }
    }

    const noDuplicateChat = chatNoDuplicate(newChats);
    ////console.log('addNewTicketToChat-newchatlist', noDuplicateChat)
    setChatList(noDuplicateChat);
  };

  const addNewChatToChats = async (newMessage) => {
    if (newMessage?.chat) {
      // emit coming from chat
      const isHaveTargetChat = chatList.findIndex((ch) => ch.id === newMessage.chat.id);
      const newChat = newMessage.chat;
      // Jangan set lastMessage untuk event sistem (tag-update, status-update)
      // karena tidak punya text dan akan merusak preview di sidebar
      const systemTypes = ["tag-update", "tag-update-resolve", "status-update"];
      if (!systemTypes.includes(newMessage?.type)) {
        newChat.lastMessage = newMessage;
      }
      if (!newChat.tags) {
        const resNewChat = await serviceGetChatById(cookies.SIDikey, newChat.id);
        if (resNewChat.status === 200) {
          newChat.tags = resNewChat.data.tags;
        } else {
          newChat.tags = [];
        }
      }
      if (!newChat.channel && newChat.tickets) {
        const resDeptName = await getDepartmentByID(cookies.SIDikey, newChat.tickets[0].departmentId);
        if (resDeptName.status === 200) {
          newChat.channel = {
            department: {
              name: resDeptName.data.name,
              color: resDeptName.data.color,
            },
          };
        }
      }

      if (newMessage.chat.user && newMessage.chat.user.id !== cookies.id) {
        // chat pindah sales lain
        if (roleFunctions.includes("Access_Own")) {
          if (isHaveTargetChat >= 0) {
            //const newChat = [...chat];
            chatList.splice(isHaveTargetChat, 1);
            //setChat([...newChat]);
          }
        } else {
          if (isHaveTargetChat < 0) {
            const resNewChat = await getMissingChatData(newChat, newMessage);
            if (
              chatMatchesActiveTab(resNewChat, activeTab, cookies.role.name) &&
              chatMatchesActiveFilters(resNewChat, {
                filterUserId,
                filterTag,
                filterCampaign,
                filterDepartment,
                filterDate,
              })
            ) {
              const noDuplicateChat = addChatWithoutDuplication(resNewChat, chatList);
              setChatList(noDuplicateChat);
            }
          }
        }
      } else {
        if (isHaveTargetChat < 0) {
          // no new chat in chatList
          const resNewChat = await getMissingChatData(newChat, newMessage);
          if (newMessage.text && newMessage.text.includes(": ASSIGN MANUAL")) {
            const formattedDate = new Date(Date.now()).toLocaleString("en-GB", {
              month: "numeric",
              year: "numeric",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false, // Ensuring 24-hour format
            });

            const dataMessage = {
              type: "PURCHASE",
              text: `ASSIGN INI DITERIMA oleh ${newChat.user.firstName} ${newChat.user.lastName}, di WEB pada ${formattedDate}`,
              chatId: newChat.id,
              wa_id: newChat.customerPhone,
              ticketId: newChat.tickets[0].id,
              fromMe: true,
            };

            await serviceSendMessage(cookies.SIDkey, dataMessage);
          }
          if (
            chatMatchesActiveTab(resNewChat, activeTab, cookies.role.name) &&
            chatMatchesActiveFilters(resNewChat, {
              filterUserId,
              filterTag,
              filterCampaign,
              filterDepartment,
              filterDate,
            })
          ) {
            const noDuplicateChat = addChatWithoutDuplication(resNewChat, chatList);
            setChatList(noDuplicateChat);
          }
        }
      }
    } else {
      // emit coming from rotator
      if (newMessage?.chat?.user?.id ?? newMessage.userId === cookies.id) {
        const resNewChat = await serviceGetChatById(cookies.SIDikey, newMessage.chatId);
        if (resNewChat.status === 200) {
          const resDeptName = await getDepartment(cookies.SIDikey, resNewChat.data.user.departmentId);
          if (resDeptName.status === 200) {
            const getCurrentDept = resDeptName.data.data.find((item) => item.id === resNewChat.data.user.departmentId);
            const newChat = resNewChat.data;
            const getTicketBychatId = await serviceGetTicketsById(cookies.SIDikey, newMessage.ticket[0].id);
            if (getTicketBychatId.status === 200) {
              newChat.tickets = getTicketBychatId.data.data;
              newChat.user.department = getCurrentDept;
              newChat.lastMessage.ticketId = newMessage.ticket[0].id;
              newChat.channel.department = newMessage.department;

              if (chatMatchesActiveTab(newChat, activeTab, cookies.role.name)) {
                const noDuplicateChat = combine2ChatNoDuplicate(newChat, chatList);
                setChatList(noDuplicateChat);
              }
            }
          }
        }
      }
    }
    playSound();
  };

  const getMissingChatData = async (newChat, newMessage) => {
    // multi department bug
    const newChatData = newChat;
    if (!newChat.tickets) {
      const resGetTickets = await serviceGetTicketById(cookies.SIDikey, newMessage.ticketId);
      if (resGetTickets.status === 200) {
        newChatData.tickets = [resGetTickets.data];
      }
    }
    if (!newChat.contactId) {
      const resGetChat = await serviceGetChatById(cookies.SIDikey, newMessage.chat.id);
      if (resGetChat.status === 200) {
        newChatData.contactId = resGetChat.contactId;
      }
    }
    //if (!newChat.user.department) {
    //  const resDeptName = await getDepartment(cookies.SIDikey, newChat.user.departmentId);
    //  if (resDeptName.status === 200) {
    //    const getCurrentDept = resDeptName.data.data.find((item) => item.id === newChat.user.departmentId);
    //    newChat.user.department = getCurrentDept;
    //  }
    //}
    if (!newChat.channel && newChat.tickets) {
      const resDeptName = await getDepartmentByID(cookies.SIDikey, newChat.tickets[0].departmentId);
      if (resDeptName.status === 200) {
        newChatData.channel = {
          department: {
            name: resDeptName.data.name,
            color: resDeptName.data.color,
          },
        };
      }
    }
    return newChat;
    //setChat([newChat, ...chat]);
  };
  // Filtering users by search
  useEffect(() => {
    if (textFilter !== "") {
      const filteredObject = chatList.filter((item) => {
        return item.name.toLowerCase().includes(textFilter.toLowerCase());
      });
      filterMessage(filteredObject);
    } else {
      setFilteredChatList([]);
      setFilteredMessageList([]);
      setAfterCursorSearchedMessage(null);
      refreshChatList();
    }

    //console.log(filteredChatList);
  }, [searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let newChats = [];
    chatList.forEach((ch) => {
      if (ch.id === selectedId) {
        switch (cookies.role.name) {
          case "SALES":
            ch.status = ch.status === "UNOPENED" ? "OPENED" : ch.status;
            ch.unreadCount = 0;
            break;
          case "CS":
            ch.csStatus = ch.csStatus === "UNOPENED" ? "OPENED" : ch.csStatus;
            ch.unreadCountCs = 0;
            break;
          case "SUPER ADMIN":
            ch.superStatus = ch.superStatus === "UNOPENED" ? "OPENED" : ch.superStatus;
            ch.unreadCountSuper = 0;
            break;
          case "HEAD":
            ch.headStatus = ch.headStatus === "UNOPENED" ? "OPENED" : ch.headStatus;
            ch.unreadCountHead = 0;
            break;
          case "ADMIN":
            ch.adminStatus = ch.adminStatus === "UNOPENED" ? "OPENED" : ch.adminStatus;
            ch.unreadCountAdmin = 0;
            break;
          case "AUDITOR":
            ch.auditorStatus = ch.auditorStatus === "UNOPENED" ? "OPENED" : ch.auditorStatus;
            ch.unreadCountAuditor = 0;
            break;
          case "SYSTEM ADMIN":
            ch.auditorSysAdmin = ch.auditorSysAdmin === "UNOPENED" ? "OPENED" : ch.auditorSysAdmin;
            ch.unreadCountSysAdmin = 0;
            break;
          default:
            break;
        }
      }
      newChats.push(ch);
    });
    const selectedChatTemp = newChats.find((item) => item.id === selectedId);
    setSelectedChat(selectedChatTemp);
    setChatList([...newChats]);
  }, [selectedId]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterMessage = async (filteredObject) => {
    setIsLoading(true);
    const responseGetMessages = await serviceGetFilterChat(
      cookies.SIDikey,
      cookies.role.name,
      textFilter,
      cookies.id,
      cookies.departmentId,
      roleFunctions,
      activeTab,
      filterUserId,
      filterTag.toString(),
      filterCampaign.toString(),
      filterDepartment.toString(),
      filterDate.dateFrom ? filterDate.dateFrom.toISOString() : "",
      filterDate.dateTo ? filterDate.dateTo.toISOString() : "",
    );
    if (new RegExp(/20+/).test(responseGetMessages.status)) {
      const messageData = responseGetMessages.data.messages.data;
      const chatData = responseGetMessages.data.chats.data;
      // Backend already sorted, no need to re-sort

      ////console.log('sorted', chatData);

      const combinedWithoutDuplicates = combine2ChatNoDuplicate(filteredObject, chatData);

      setFilteredChatList(combinedWithoutDuplicates);
      setFilteredMessageList(messageData);
      setAfterCursorSearchedMessage(responseGetMessages.data.messages.meta);
    } else {
      ////console.log("Error get Messages from DB", responseGetMessages);
    }

    setIsLoading(false);
  };

  const onInputChange = (e) => {
    setTextFilter(e.target.value);
  };

  const onFilterClick = (prop) => {
    setFilterTab(prop);
  };

  useEffect(() => {
    checkChatIDinUrl();
  }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const checkPhoneInUrl = async () => {
      const params = new URLSearchParams(window.location.search);
      if (params.get("chatID")) return;

      const phone = params.get("phone");
      if (!phone || isLoading) return;

      const status = activeTab !== "all" ? activeTab.toUpperCase() : "";
      const res = await serviceGetFilterChat(
        cookies.SIDikey,
        cookies.role.name,
        phone,
        cookies.id,
        cookies.departmentId,
        roleFunctions,
        status,
      );

      if (new RegExp(/20+/).test(res.status)) {
        const chats = res.data?.chats?.data || [];
        if (chats.length > 0) {
          setPhoneNotFoundMessage(null);
          setChatList((prevChatList) => addChatWithoutDuplication(chats[0], prevChatList));
          setSelectedId(chats[0].id);
        } else {
          setPhoneNotFoundMessage(phone);
        }
      } else {
        setPhoneNotFoundMessage(phone);
      }
    };
    checkPhoneInUrl();
  }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleTab = (tab) => {
    if (activeTab === tab) return;

    if (tab === "chatbot") {
      setIsBotFilter(true);
      setActiveTab("chatbot");
    } else {
      setIsBotFilter(false);
      onFilterClick(tab);
      setActiveTab(tab);
    }
    setSelectedId(null);

    // keep the URL in sync with the manually selected tab; "all" clears it
    const params = new URLSearchParams(location.search);
    if (tab === "all") {
      params.delete("tab");
    } else {
      params.set("tab", tab);
    }
    history.replace({ search: params.toString() });
  };

  return (
    <React.Fragment>
      <Head title="Chat / Messenger"></Head>
      <Alert
        color="warning"
        isOpen={showResolvedBanner}
        toggle={() => {
          localStorage.setItem(RESOLVED_BANNER_DISMISSED_KEY, "true");
          setShowResolvedBanner(false);
        }}
        className="mb-2 mx-3"
        style={{
          position: "relative",
          bottom: "100%",
          left: 0,
          right: 0,
          zIndex: 30,
          marginTop: "0.5rem",
          marginBottom: "0.5rem",
        }}
      >
        <Icon name="alert-circle" className="mr-1" />
        Jangan lupa ubah status tiket menjadi <strong>RESOLVED</strong> saat deal terjadi, agar penjualan Anda tercatat
        di sistem SPSS.
      </Alert>
      <ContentAlt>
        <div className="nk-chat">
          <div className={`nk-chat-aside ${mobileView ? "has-aside" : ""}`}>
            <SimpleBar className="w-100">
              <div className="d-flex w-100" style={{ height: "40px", width: "100%" }}>
                <Nav tabs style={{ border: "none", flexWrap: "nowrap" }}>
                  <NavItem>
                    <NavLink
                      style={{
                        marginLeft: "10px",
                        height: "40px",
                        color: activeTab === "all" ? "#4461F2" : "",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        toggleTab("all");
                      }}
                    >
                      <span className="d-flex align-items-center">
                        All
                        <span className="ml-1">
                          ({chatList.filter((chat) => chatMatchesActiveTab(chat, "unopened", cookies.role.name)).length})
                        </span>
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ height: "40px", color: activeTab === "unopened" ? "#4461F2" : "", cursor: "pointer" }}
                      onClick={() => {
                        toggleTab("unopened");
                      }}
                    >
                      Unopened
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ height: "40px", color: activeTab === "opened" ? "#4461F2" : "", cursor: "pointer" }}
                      onClick={() => {
                        toggleTab("opened");
                      }}
                    >
                      Opened
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ height: "40px", color: activeTab === "pending" ? "#4461F2" : "", cursor: "pointer" }}
                      onClick={() => {
                        toggleTab("pending");
                      }}
                    >
                      Pending
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{
                        height: "40px",
                        color: activeTab === "resolved" ? "#4461F2" : "",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        toggleTab("resolved");
                      }}
                    >
                      Resolved
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{
                        marginRight: "10px",
                        height: "40px",
                        color: activeTab === "solved" ? "#4461F2" : "",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        toggleTab("solved");
                      }}
                    >
                      Solved
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </SimpleBar>
            <div className="nk-chat-aside-search p-2" style={{ backgroundColor: "#e5e9f2", marginBottom: "15px" }}>
              <div className="form-group">
                <div className="form-control-wrap d-flex">
                  <div className="form-icon form-icon-left">
                    <Icon name="search"></Icon>
                  </div>
                  <Input
                    type="text"
                    className="form-round"
                    id="default-03"
                    placeholder="Search by name"
                    onChange={(e) => onInputChange(e)}
                    style={{ backgroundColor: "white" }}
                  />

                  {/* Filter Tags */}

                  <div
                    className="btn btn-round btn-icon btn-light dropdown-toggle ml-2"
                    onClick={() => setIsModalTagFilterOpen(true)}
                  >
                    <ChatModalFilter
                      cookies={cookies}
                      isModalTagFilterOpen={isModalTagFilterOpen}
                      setIsModalTagFilterOpen={setIsModalTagFilterOpen}
                      setFilterTag={setFilterTag}
                      filterTag={filterTag}
                    />
                    <Icon name="filter-alt"></Icon>
                    {filterTag.length > 0 ? <span className="status dot dot-lg dot-success"></span> : <></>}
                  </div>

                  {/* Filter Campaign */}

                  <div
                    className="btn btn-round btn-icon btn-light dropdown-toggle"
                    onClick={() => setIsModalCampaignFilterOpen(true)}
                  >
                    <ChatModalFilterCampaign
                      cookies={cookies}
                      isModalCampaignFilterOpen={isModalCampaignFilterOpen}
                      setIsModalCampaignFilterOpen={setIsModalCampaignFilterOpen}
                      setFilterCampaign={setFilterCampaign}
                      filterCampaign={filterCampaign}
                    />
                    <Icon name="cc-alt2"></Icon>
                    {filterCampaign.length > 0 ? <span className="status dot dot-lg dot-success"></span> : <></>}
                  </div>

                  {/* Filter Department */}

                  <div
                    className="btn btn-round btn-icon btn-light dropdown-toggle"
                    onClick={() => setIsModalDepartmentFilterOpen(true)}
                  >
                    <ChatModalFilterDepartment
                      cookies={cookies}
                      roleFunctions={roleFunctions}
                      isModalDepartmentFilterOpen={isModalDepartmentFilterOpen}
                      setIsModalDepartmentFilterOpen={setIsModalDepartmentFilterOpen}
                      setFilterDepartment={setFilterDepartment}
                      filterDepartment={filterDepartment}
                    />
                    <Icon name="building"></Icon>
                    {filterDepartment.length > 0 ? <span className="status dot dot-lg dot-success"></span> : <></>}
                  </div>

                  {/* Filter User */}
                  {(roleFunctions.includes("Access_Own_Dept") || roleFunctions.includes("Access_All_Dept")) && (
                    <div
                      className="btn btn-round btn-icon btn-light dropdown-toggle"
                      onClick={() => setIsModalFilterUserOpen(true)}
                    >
                      <ChatFilterUser
                        cookies={cookies}
                        isModalFilterUserOpen={isModalFilterUserOpen}
                        setIsModalFilterUserOpen={setIsModalFilterUserOpen}
                        userDetail={userDetail}
                        filterChatByUserId={filterChatByUserId}
                        isIncludeChatbot={roleFunctions.includes("View_Chatbot")}
                        BOT_ID={BOT_ID}
                        setFilterUserName={setFilterUserName}
                      />
                      <Icon name="user-list"></Icon>
                      {filterUserId ? <span className="status dot dot-lg dot-success"></span> : <></>}
                    </div>
                  )}

                  {/* Filter Date — non-Sales only (OPI-237) */}
                  {cookies.role.name !== "SALES" && (
                    <div
                      className="btn btn-round btn-icon btn-light dropdown-toggle"
                      onClick={() => setIsModalDateFilterOpen(true)}
                    >
                      <ChatModalFilterDate
                        isModalDateFilterOpen={isModalDateFilterOpen}
                        setIsModalDateFilterOpen={setIsModalDateFilterOpen}
                        setFilterDate={setFilterDate}
                        filterDate={filterDate}
                      />
                      <Icon name="calendar"></Icon>
                      {filterDate.dateFrom || filterDate.dateTo ? (
                        <span className="status dot dot-lg dot-success"></span>
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <ChatAsideBody
              cookies={cookies}
              onInputChange={onInputChange}
              setCheckedTag={setCheckedTag}
              isModalTagAssignOpen={isModalTagAssignOpen}
              setIsModalTagAssignOpen={setIsModalTagAssignOpen}
              afterCursorChat={afterCursorChat}
              setAfterCursorChat={setAfterCursorChat}
              filterTab={filterTab}
              isSearch={searchText !== "" ? true : false}
              afterCursorSearchedMessage={afterCursorSearchedMessage}
              setAfterCursorSearchedMessage={setAfterCursorSearchedMessage}
              searchText={searchText}
              isLoading={isLoading}
              status={activeTab !== "all" ? activeTab.toUpperCase() : ""}
              filterTag={filterTag}
              setContextMessage={setContextMessage}
              roleFunctions={roleFunctions}
              filterUserId={filterUserId}
              filterUserName={filterUserName}
              filterCampaign={filterCampaign}
              filterDepartment={filterDepartment}
              filterDate={filterDate}
            />
          </div>
          {selectedId !== null ? (
            <ReplyContext.Provider
              value={{ value: [replyMessage, setReplyMessage], value2: [contextMessage, setContextMessage] }}
            >
              <ChatBody
                AfterAssign={() => refreshChatList()}
                cookies={cookies}
                mobileView={mobileView}
                setMobileView={setMobileView}
                setSelectedId={setSelectedId}
                setIsModalTagAssignOpen={setIsModalTagAssignOpen}
                isModalTagAssignOpen={isModalTagAssignOpen}
                checkedTag={checkedTag}
                setCheckedTag={setCheckedTag}
                userDetail={userDetail}
              />
            </ReplyContext.Provider>
          ) : (
            <div className="nk-chat-body">
              <div className="nk-chat-blank">
                <div className="nk-chat-blank-icon">
                  <Icon name="chat" className="icon-circle icon-circle-xxl bg-white"></Icon>
                </div>
                <div className="nk-chat-blank-btn">
                  <h6>
                    {phoneNotFoundMessage ? (
                      <>
                        Phone not found: <strong>{phoneNotFoundMessage}</strong>
                      </>
                    ) : (
                      "Please select a chat to start messaging"
                    )}
                  </h6>
                </div>
              </div>
            </div>
          )}
        </div>
      </ContentAlt>
    </React.Fragment>
  );
};

export default Chat;
